import { Component, computed, EventEmitter, Output, signal } from '@angular/core';
import { Icon, iconList } from './icon-list';

@Component({
  selector: 'rk-icon-search',
  templateUrl: './icon-search.component.html',
  styleUrls: ['./icon-search.component.scss'],
  standalone: false,
})
export class IconSearchComponent {
  @Output() readonly iconSelected = new EventEmitter<Icon>();

  searchText = signal('');

  itemSet = computed(() => {
    const search = this.searchText().toLowerCase();
    const filtered = search
      ? iconList.filter(icon => icon.name.toLowerCase().includes(search))
      : iconList;

    return this.generateDataChunk(filtered);
  });

  private generateDataChunk(data: Icon[], chunkSize = 6): Icon[][] {
    const dataChunk: Icon[][] = [];
    for (let index = 0; index < data.length; index += chunkSize) {
      dataChunk.push(data.slice(index, index + chunkSize));
    }

    return dataChunk;
  }

  selectIcon(icon: Icon) {
    this.iconSelected.emit(icon);
  }
}
